// src/services/entitiesLookupService.js
import { fetchWithAuth } from '../utils/fetchWithAuth';

/**
 * Intenta obtener entidades para autocompletar:
 * - /regional-entities
 * - /regional-entities/all
 * - /regional-entities?size=1000 (por si hay paginación)
 * Ajusta si tu API real usa otra ruta.
 */
async function tryEndpoint(path) {
  const res = await fetchWithAuth(path, { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status} on ${path}`);
  const data = await res.json().catch(() => ({}));
  // desanidar formas típicas de respuesta
  const arr =
    (Array.isArray(data) && data) ||
    data.data ||
    data.items ||
    data.results ||
    data.rows ||
    [];
  return Array.isArray(arr) ? arr : [];
}

export const listEntitiesForSuggestions = async () => {
  let list = [];
  const candidates = [
    '/regional-entities?size=1000',
    '/regional-entities/all',
    '/regional-entities',
  ];

  for (const path of candidates) {
    try {
      list = await tryEndpoint(path);
      if (list.length) break;
    } catch (_) {
      // probamos el siguiente
    }
  }

  if (!list.length) {
    console.warn('[entitiesLookup] No se encontraron entidades en los endpoints probados');
    return [];
  }

  // normalizar -> [{id, name}]
  const norm = list
    .map((e) => ({
      id: e.id || e.uuid || e._id || e.entityId || e.slug,
      name: e.name || e.title || e.business_name || e.trade_name || e.displayName,
    }))
    .filter((e) => e.id && e.name);

  // quitar duplicados por nombre (case-insensitive)
  const seen = new Set();
  return norm.filter((e) => {
    const key = e.name.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
